// import React, { Component, createContext, useContext } from 'react';
// import { firebaseObj, generateUserDocument } from '../firebase';

import React from 'react';

let user;
let authExpiry = localStorage.getItem('_authExpiry');
if (authExpiry) {
    let cookieExpired = new Date().getTime() > new Date(authExpiry).getTime();
    if (cookieExpired) localStorage.clear();
    else user = JSON.parse(localStorage.getItem('user'));
}

const UserContext = React.createContext({
    user: user || {},
    pending: false,
    setUser: (u) => {},
    setPending: (p) => {}
});

export const UserProvider = UserContext.Provider;
export default UserContext;

// class UserProvider extends Component {
//     state = {
//         user: null,
//         pending: false
//     };

//     componentDidMount = async () => {
//         this.setState({ pending: false });
//     };

//     render() {
//         const { user, pending } = this.state;

//         return (
//             <UserContext.Provider value={{ user, pending }}>
//                 {this.props.children}
//             </UserContext.Provider>
//         );
//     }
// }

// export default UserProvider;



// WEBPACK FOOTER //
// ./demo/src/providers/UserProvider.js